import { render } from "./Origin.vue?vue&type=template&id=bb3d38f0&ts=true"
import script from "./Origin.vue?vue&type=script&lang=ts"
export * from "./Origin.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__